// eslint-disable-next-line import/no-cycle
import Allocation from './Allocation';

const Allocations = (props) => {
  const { product } = props;
  if (!product.allocations || product.allocations.length === 0) {
    return null;
  }
  return product.allocations.map((allocation) => (
    <Allocation
      key={allocation.allocationId}
      allocation={allocation}
      product={product}
    />
  ));
};

export default Allocations;
